/* eslint-disable react-native/no-inline-styles */
import React, { useEffect, useState } from 'react';
import { View, Text, TouchableOpacity } from 'react-native';
import i18n from 'i18n-js';
import moment from 'moment';
import { connect } from 'react-redux';

import { scale, Element } from '@components/frame';
import { convertTimeLetter, isPhone } from '@helpers';
import ColorWrapper from '@styles/colors';
import { font } from '@styles/fonts';

import { authenticateWalboardDevice, closeDeviceActivation } from '@reducers/device';

import Loading from '@components/loading';
import { modalBg, SCREEN_BORDER_RADIUS } from '@v2/pages/common/constants/base.constants';

let timerID;

const ActivateDevice = (props) => {
  const { C, showDeviceActivation, authenticationCode, closeDeviceActivation, authenticateWalboardDevice, expirationDateTime } = props;

  useEffect(() => {
    if (timerID) {
      clearInterval(timerID);
    }
    if (showDeviceActivation) {
      setSeconds(exTime);
      trigerTimer();
    }

    return () => {
      clearInterval(timerID);
    };
  }, [showDeviceActivation, authenticationCode]);

  const exDate = moment.utc(expirationDateTime).diff(moment(), 'seconds');

  const exTime = exDate || 120;
  const [seconds, setSeconds] = useState(exDate);
  const [loading, setLoading] = useState(false);

  const trigerTimer = () => {
    let s = exTime;
    timerID = setInterval(() => {
      if (s <= 1) {
        clearInterval(timerID);
        s = exTime;
        setSeconds(s);
        (async () => {
          await closeDeviceActivation();
        })();
        return;
      }
      const nS = s - 1;
      setSeconds(nS);
      s = nS;
    }, 1000);
  };

  if (!showDeviceActivation) {
    return <View />;
  }

  const time = convertTimeLetter(seconds);
  return (
    <View
      style={{
        height: '100%',
        width: '100%',
        backgroundColor: C('Overlay/Light/Picture dark'),
        justifyContent: 'center',
        alignContent: 'center',
        alignItems: 'center',
        position: 'absolute',
        zIndex: 100000,
      }}
    >
      <Element
        {...{
          config: {
            width: 620,
            height: 480,
            backgroundColor: C(modalBg),
            borderRadius: scale(SCREEN_BORDER_RADIUS),
          },
          configMobile: {
            width: 340,
            height: 310,
          },
        }}
      >
        {loading ? (
          <Loading background={'transparent'} />
        ) : (
          <View style={{ width: '100%', height: '100%' }}>
            <View style={{ width: '100%', marginTop: scale(isPhone ? 17 : 25) }}>
              <Text style={[font['Title 1'], { color: C('Label/Light/Primary'), textAlign: 'center', fontSize: scale(isPhone ? 20 : 33) }]}>
                {i18n.t('Activate')}
              </Text>
            </View>
            <View style={{ width: '100%', marginTop: scale(isPhone ? 8 : 17) }}>
              <Text style={[font['Body'], { color: C('Label/Light/Primary'), textAlign: 'center', fontSize: scale(isPhone ? 16 : 24) }]}>
                {i18n.t('New device wants to activate now.')}
              </Text>
              <Text
                style={[
                  font['Body'],
                  { color: C('Label/Light/Primary'), textAlign: 'center', fontSize: scale(isPhone ? 16 : 24), marginTop: scale(10) },
                ]}
              >
                {i18n.t('Do you see this code on the new Device?')}
              </Text>
            </View>
            <View
              style={{
                width: '100%',
                marginTop: scale(isPhone ? 17 : 45),
                justifyContent: 'center',
                alignItems: 'center',
                alignContent: 'center',
                paddingLeft: scale(isPhone ? 20 : 0),
                paddingRight: scale(isPhone ? 20 : 0),
              }}
            >
              <View
                style={{
                  width: isPhone ? '100%' : scale(500),
                  height: scale(isPhone ? 68 : 125),
                  paddingLeft: scale(30),
                  paddingRight: scale(30),
                  backgroundColor: C('Button/Light/Tertiary'),
                  borderRadius: scale(10),
                  justifyContent: 'center',
                  alignItems: 'center',
                  alignContent: 'center',
                }}
              >
                <Text
                  style={[
                    {
                      color: C('Label/Light/Primary'),
                      fontSize: scale(isPhone ? 53 : 120),
                      lineHeight: scale(isPhone ? 77 : 135),
                      letterSpacing: scale(-1),
                      width: '100%',
                      textAlign: 'center',
                    },
                  ]}
                >
                  {authenticationCode}
                </Text>
              </View>
            </View>
            <View
              style={{ width: '100%', marginTop: scale(isPhone ? 4 : 5), justifyContent: 'center', alignItems: 'center', alignContent: 'center' }}
            >
              <Text style={[{ color: C('Label/Light/Secondary'), fontSize: scale(isPhone ? 14 : 25), fontVariant: ['tabular-nums'] }]}>
                {i18n.t('Code expires in:')} {time.m}:{time.s}
              </Text>
            </View>
            <View
              style={{
                width: '100%',
                marginTop: scale(isPhone ? 24 : 46),
                justifyContent: 'center',
                alignItems: 'center',
                alignContent: 'center',
                flexDirection: 'row',
              }}
            >
              <TouchableOpacity activeOpacity={1} onPress={closeDeviceActivation}>
                <View
                  style={{
                    backgroundColor: C('Button/Light/Tertiary'),
                    borderRadius: scale(6),
                    width: scale(isPhone ? 140 : 224),
                    height: scale(isPhone ? 48 : 54),
                    justifyContent: 'center',
                    alignItems: 'center',
                    alignContent: 'center',
                    marginRight: scale(isPhone ? 20 : 52),
                  }}
                >
                  <Text style={[{ color: C('Label/Light/Primary'), fontSize: scale(isPhone ? 16 : 20) }]}>{i18n.t('No, ignore')}</Text>
                </View>
              </TouchableOpacity>
              <TouchableOpacity
                activeOpacity={1}
                onPress={async () => {
                  setLoading(true);
                  await authenticateWalboardDevice();
                  await closeDeviceActivation();
                  setLoading(false);
                }}
              >
                <View
                  style={{
                    backgroundColor: C('Button/Light/Primary'),
                    borderRadius: scale(6),
                    width: scale(isPhone ? 140 : 224),
                    height: scale(isPhone ? 48 : 54),
                    justifyContent: 'center',
                    alignItems: 'center',
                    alignContent: 'center',
                  }}
                >
                  <Text style={[{ color: C('Label/Light/Inverted'), fontSize: scale(isPhone ? 16 : 20) }]}>{i18n.t('Yes, activate')}</Text>
                </View>
              </TouchableOpacity>
            </View>
          </View>
        )}
      </Element>
    </View>
  );
};

export default connect(
  ({ signalR: { showDeviceActivation, authenticationCode, expirationDateTime } }) => ({
    showDeviceActivation,
    authenticationCode,
    expirationDateTime,
  }),
  {
    closeDeviceActivation,
    authenticateWalboardDevice,
  }
)(ColorWrapper(ActivateDevice));
